import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { MoreVertical, Eye } from "lucide-react";
import { useAppDispatch } from "../../../../hooks";
import {
  setAppealModal,
  setCaseDetailModal,
  setSubmitModal,
} from "../../../../states/slices/globalReducer";
import { useNavigate } from "react-router-dom";

const columnHelper = createColumnHelper<any>();

const ActionCell = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="p-2 text-[#98A2B3] hover:text-[#475467] transition-colors focus:outline-none">
        <MoreVertical className="w-5 h-5" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          anchor="bottom end"
          className="absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() =>
                    navigate("/registrar1-payment/case-folders/view")
                  }
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Open folder
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => dispatch(setCaseDetailModal(true))}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  View case details
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Query
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => dispatch(setAppealModal(true))}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Assign Appeal number
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => dispatch(setSubmitModal(true))}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Submit to Registrar 2
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export const Registrar1PaymentColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("date", {
    header: "Date",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span
        className="text-[#464255] font-medium block min-w-[200px]"
        title={info.getValue()}
      >
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("details", {
    header: "Details",
    cell: () => (
      <div className="flex items-center gap-1 cursor-pointer hover:opacity-80">
        <span className="text-[#464255]">View</span>
        <Eye className="w-4 h-4 text-[#464255]" />
      </div>
    ),
  }),
  columnHelper.accessor("query_status", {
    header: "Query status",
    cell: (info) => (
      <span className="text-[#464255]">{info.getValue() || "_______"}</span>
    ),
  }),
  columnHelper.accessor("payment", {
    header: "Payment",
    cell: (info) => {
      const value = info.getValue();
      if (value === "Successful") {
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#ECFDF3] text-[#027A48] border border-[#ABEFC6]">
            {value}
          </span>
        );
      }
      return <span className="text-[#464255]">{value || "_______"}</span>;
    },
  }),
  columnHelper.accessor("verify_payment", {
    header: "Verify payment",
    cell: (info) => {
      const value = info.getValue();
      if (value) {
        return (
          <button className="bg-[#00B074] text-white px-3 py-1.5 rounded-full text-xs font-medium hover:bg-[#009060] transition-colors whitespace-nowrap">
            Paystack receipt
          </button>
        );
      }
      return <span className="text-[#464255]">_______</span>;
    },
  }),
  columnHelper.accessor("assigned_registrar", {
    header: "Assigned Reg.",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("time_spent", {
    header: "Time Spent",
    cell: (info) => (
      <span className="text-[#00B074] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("appeal_number", {
    header: "Appeal numb",
    cell: (info) => (
      <span className="text-[#464255]">{info.getValue() || "_______"}</span>
    ),
  }),
  columnHelper.display({
    id: "actions",
    header: "Action",
    cell: () => <ActionCell />,
  }),
];
